interface LogoItem {
  name: string
  src: string
}

function toSlug(name: string) {
  return name.toLowerCase().replace(/\s+/g, '-')
}

export default function LogoRail({ items }: { items: LogoItem[] }) {
  const mid = Math.ceil(items.length / 2)
  const row1 = items.slice(0, mid)
  const row2 = items.slice(mid)

  const repeated1 = [...row1, ...row1]
  const repeated2 = [...row2, ...row2]
  const repeatedAll = [...items, ...items]

  return (
    <div className="marketing-logo-rail">
      <div className="marketing-logo-fade left" />
      <div className="marketing-logo-fade right" />

      {/* Single row on desktop */}
      <div className="marketing-logo-track marketing-logo-track-desktop">
        {repeatedAll.map((item, index) => (
          <div key={`${item.name}-${index}`} className="marketing-logo-card" data-brand={toSlug(item.name)}>
            <img src={item.src} alt={item.name} className="h-8 w-auto brightness-0 invert opacity-80" />
          </div>
        ))}
      </div>

      {/* Two compact rows on mobile */}
      <div className="marketing-logo-track-mobile">
        <div className="marketing-logo-track marketing-logo-track-row1">
          {repeated1.map((item, index) => (
            <div key={`r1-${item.name}-${index}`} className="marketing-logo-card" data-brand={toSlug(item.name)}>
              <img src={item.src} alt={item.name} className="h-8 w-auto brightness-0 invert opacity-80" />
            </div>
          ))}
        </div>
        <div className="marketing-logo-track marketing-logo-track-row2">
          {repeated2.map((item, index) => (
            <div key={`r2-${item.name}-${index}`} className="marketing-logo-card" data-brand={toSlug(item.name)}>
              <img src={item.src} alt={item.name} className="h-8 w-auto brightness-0 invert opacity-80" />
            </div>
          ))}
        </div>
      </div>
    </div>
  )
}
